module.exports = __webpack_public_path__ + "img/cola.ee878dc4.jpg";